// ** Redux Imports
import { createSlice } from "@reduxjs/toolkit";

// ** ThemeConfig Import
import themeConfig from "@configs/themeConfig";
import { setSessionMenuFirst } from "utils";

const initialMenuCollapsed = () => {
  const item = window.localStorage.getItem("menuCollapsed");
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : themeConfig.layout.menu.isCollapsed;
};

const initialDirection = () => {
  const item = window.localStorage.getItem("direction");
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : themeConfig.layout.isRTL;
};

const initialSkin = () => {
  const item = window.localStorage.getItem("skin");
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : themeConfig.layout.skin;
};

const initialContentWidth = () => {
  const item = window.localStorage.getItem("contentWidth");

  return JSON.parse(item);
};

export const layoutSlice = createSlice({
  name: "layout",
  initialState: {
    skin: initialSkin(),
    isRTL: initialDirection(),
    layout: themeConfig.layout.type,
    lastLayout: themeConfig.layout.type,
    menuCollapsed: initialMenuCollapsed(),
    footerType: themeConfig.layout.footer.type,
    navbarType: themeConfig.layout.navbar.type,
    menuHidden: themeConfig.layout.menu.isHidden,
    contentWidth: initialContentWidth(),
    navbarColor: themeConfig.layout.navbar.backgroundColor,
    menuList: [],
    isReplaceMenu: false,
    menuSelected: {},
    layoutSize: "full",
    layoutSizePopover: false,
  },
  reducers: {
    handleRTL: (state, action) => {
      state.isRTL = action.payload;
      window.localStorage.setItem("direction", JSON.stringify(action.payload));
    },
    handleSkin: (state, action) => {
      state.skin = action.payload;
      window.localStorage.setItem("skin", JSON.stringify(action.payload));
    },
    handleLayout: (state, action) => {
      state.layout = action.payload;
    },
    handleFooterType: (state, action) => {
      state.footerType = action.payload;
    },
    handleNavbarType: (state, action) => {
      state.navbarType = action.payload;
    },
    handleMenuHidden: (state, action) => {
      state.menuHidden = action.payload;
    },
    handleLastLayout: (state, action) => {
      state.lastLayout = action.payload;
    },
    handleNavbarColor: (state, action) => {
      state.navbarColor = action.payload;
    },
    handleContentWidth: (state, action) => {
      state.contentWidth = action.payload;
      window.localStorage.setItem(
        "contentWidth",
        JSON.stringify(action.payload),
      );
    },
    handleMenuList: (state, action) => {
      state.menuList = action.payload;

      const menu = action.payload.filter(item => !item?.externalLink);

      let menuFirst = "";

      if (menu[0]?.link) {
        menuFirst = menu[0]?.link;
      }
      if (!menu[0]?.link && menu[0]?.navLink) {
        menuFirst = menu[0]?.navLink;
      }
      if (
        !menu[0]?.link &&
        !menu[0]?.navLink &&
        menu[0]?.children?.length > 0
      ) {
        menuFirst = menu[0]?.children[0]?.link || menu[0]?.children[0]?.navLink;
      }

      setSessionMenuFirst(menuFirst ? menuFirst : "/usuario/perfil");
    },
    handleClearMenu: (state, action) => {
      state.menuList = action.payload;
    },
    handleMenuReplace: (state, action) => {
      state.isReplaceMenu = action.payload?.value;
    },
    handleMenuCollapsed: (state, action) => {
      state.menuCollapsed = action.payload;
      window.localStorage.setItem(
        "menuCollapsed",
        JSON.stringify(action.payload),
      );
    },
  },
});

export const {
  handleRTL,
  handleSkin,
  handleLayout,
  handleLastLayout,
  handleMenuHidden,
  handleNavbarType,
  handleFooterType,
  handleNavbarColor,
  handleContentWidth,
  handleMenuCollapsed,
  handleMenuList,
  handleMenuSelected,
  handleClearMenu,
  handleMenuReplace,
} = layoutSlice.actions;

export default layoutSlice.reducer;
